var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagUnitedKingdom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1277_3077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9996 0H0.538086V12H18.9996V0Z",
    fill: "#084CA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9996 0H16.69L11.8803 3.1219V0H7.64445V3.25L2.5605 0H0.538086V1.62286L4.18411 3.96524H0.538086V8.12238H4.15477L0.538086 10.4814V12H2.93093L7.64445 8.92905V12H11.8803V8.87524L16.7501 12H18.9996V10.4981L15.2944 8.1219H18.9996V3.96476H15.3127L18.9996 1.56476V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48122 3.96476L0.538086 0V1.04667L4.97836 3.96524H6.48122V3.96476Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0654 8.12256L18.9999 12.0002V11.0268L14.5683 8.12256H13.0654Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64445 8.12255H6.42205L0.538086 12.0002H1.94714L7.64445 8.31255V8.12207V8.12255Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8799 3.96476H13.0181L18.9992 0.0971429V0H17.6532L11.8799 3.72V3.96476Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9996 4.84714H10.9725V0H8.55223V4.84714H0.538086V7.24H8.55223V12H10.9725V7.24H18.9996V4.84714Z",
    fill: "#ED1C24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1277_3077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.4615,
    height: 12,
    fill: "white",
    transform: "translate(0.538086)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUnitedKingdom);
export default __webpack_public_path__ + "static/media/flag-united-kingdom.de518418ed642a4e1b72b799377b2fac.svg";
export { ForwardRef as ReactComponent };